import { AfterContentInit, Component } from '@angular/core'

import { AuthService } from '@app/modules/auth/auth.service'
import { TranslateService } from '@ngx-translate/core'

import { RoleType } from '@core/types/role.type'
import { User } from '@app/shared/models/user.model'
import { ClientStatus } from '@shared/models/client.model'
import dayjs from 'dayjs'
import { Router } from '@angular/router'

@Component({
  selector: 'lin-header-banner',
  templateUrl: './header-banner.component.html',
  styleUrls: ['./header-banner.component.scss'],
  standalone: false,
})
export class HeaderBannerComponent implements AfterContentInit {
  bannerText: string

  get currentUser(): User {
    return this.authService.getCurrentUser()
  }

  get isClientAdmin(): boolean {
    return this.currentUser?.role?.name === RoleType.Admin
  }

  get daysUntilBlocking(): number {
    return dayjs(this.currentUser?.team?.blockedBillingAt).tz().diff(dayjs().tz(), 'day')
  }

  get isGlobalMessage(): boolean {
    return this.authService.shouldShowGlobalBanner()
  }

  constructor(
    private readonly authService: AuthService,
    private readonly translate: TranslateService,
    private readonly router: Router,
  ) {}

  ngAfterContentInit(): void {
    if (this.isGlobalMessage) {
      this.bannerText = <string>this.translate.instant('BANNER.SYSTEM_DOWN')
    } else {
      switch (this.currentUser?.team?.clientStatus) {
        case ClientStatus.PartiallyBlockedBilling:
          this.bannerText = this.isClientAdmin
            ? <string>this.translate.instant('BANNER.CLIENT_STATUS.ADMIN_PARTIALLY_BLOCKED')
            : <string>this.translate.instant('BANNER.CLIENT_STATUS.USER_PARTIALLY_BLOCKED')
          break
        case ClientStatus.BlockedBilling:
          this.bannerText = this.isClientAdmin
            ? <string>this.translate.instant('BANNER.CLIENT_STATUS.ADMIN_BLOCKED')
            : <string>this.translate.instant('BANNER.CLIENT_STATUS.USER_BLOCKED')
          break
      }
    }

    setTimeout(() => {
      const billingLink = document.getElementsByClassName('warning-banner-link')
      if (billingLink.length) {
        billingLink[0].addEventListener('click', () => {
          void this.router.navigate(['/client/billing'])
        })
      }
    })
  }
}
